<template>
    <div>
        <table cellpadding="0" cellspacing="0" border="0" style="background-color: #eee; width: 100%; font-size: 14px; font-weight: 600">
            <tr v-if="$store.state.simplePlan.discountAmount  == 0">
                <td style="text-align: left; padding: 10px; font-weight: 600">
                    {{ $t("plan_calculator.total") }}
                </td>
                <td style="text-align: right; padding: 10px;">
                    <pm-price style="font-size: 12px; font-weight: 600;" :value="fullTotal" />
                </td>
            </tr>

            <template v-else>
                <tr>
                    <td style="text-align: left; padding: 10px; font-weight: 600">
                        {{ $t("plan_calculator.total_without_discount") }}
                    </td>
                    <td style="text-align: right; padding: 10px;">
                        <pm-price style="font-size: 12px; font-weight: 600;" :value="fullTotal" />
                    </td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 10px; font-weight: 600">
                        {{ $t("plan_calculator.discount") }}
                    </td>
                    <td style="text-align: right; padding: 10px;">
                        <pm-price v-if="$store.state.simplePlan.discountMode === 'currency'" style="font-size: 12px; font-weight: 600;" :value="discount" />
                        <span v-else style="font-size: 12px; font-weight: 600;">
                            {{ $store.state.simplePlan.discountAmount}} <small>%</small>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 10px; font-weight: 600">
                        {{ $t("plan_calculator.total_with_discount") }}
                    </td>
                    <td style="text-align: right; padding: 10px;">
                        <pm-price style="font-size: 12px; font-weight: 600;" :value="fullTotal - discount" />
                    </td>
                </tr>
            </template>
        </table>
    </div>
</template>

<script>
import PmOverviewHeader from "./overview-header";
export default {
    extends: PmOverviewHeader,
};
</script>
